import styled from 'styled-components';

import { ModalCloseButton as BaseModalClose } from '@components/Modal/utils';
import HorizontalScrollableList, {
  hideScrollbarMixin,
} from '@components/utils/HorizontalScrollableList';
import { UpArrowIcon, DownArrowIcon } from '@assets/icons';

import {
  FeaturesBlock,
  FeatureListContainer,
  FeatureGroupDescription,
  CustomShowMoreText,
} from './styled';

export const TopMenuItem = styled.span`
  cursor: pointer;
  color: ${(p) => p.theme.palette.darkGray};
  font-size: 14px;
  background: ${(p) => p.theme.palette.white};
  padding: 13px 20px;
  white-space: nowrap;
  height: 44px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
export const TopMenu = styled.div<{
  activeItem: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 58px;
  background: ${(p) => p.theme.palette.grey1100};
  width: 100%;
  padding: 8px 16px;
  ${TopMenuItem} {
    flex: 1;
    &[data-item='${(p) => p.activeItem}'] {
      border-bottom: solid 3px ${(p) => p.theme.palette.grey1100};
      color: ${(p) => p.theme.palette.primaryBrand};
      font-weight: 600;
    }
  }
`;

export const Container = styled.div<{ activeGallery?: string }>`
  display: none;
  position: relative;
  ${(p) => p.theme.mediaQueries.GALLERY_SMALL_SCREEN} {
    padding-top: ${(p) => (p.activeGallery ? 0 : 24)}px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${(p) => p.theme.palette.white};
    height: 100vh;
    width: 100vw;
    overflow: scroll;
    ${hideScrollbarMixin};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  background-color: ${(p) => p.theme.palette.white};
  ${FeaturesBlock} {
    padding: 0 0px;
    margin: 0;
    width: 100vw;
    height: unset;
    ${FeatureListContainer} {
      grid-template-columns: 1fr 1fr;
    }
    ${FeatureGroupDescription}, ${CustomShowMoreText} {
      margin-bottom: 20px;
    }
    overflow-y: unset;
  }
`;

export const RoomTitle = styled.span`
  color: ${({ theme }) => theme.palette.white};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  word-wrap: break-word;
  width: 95%;
`;

export const ModalClose = styled.div`
  width: 100%;
  position: relative;
  height: 60px;
  padding: 18px 16px;
  background-color: ${({ theme }) => theme.palette.grey1100};
  color: ${({ theme }) => theme.palette.white};
  display: flex;
  align-items: center;
`;
export const ModalCloseButton = styled(BaseModalClose)``;

export const GalleryItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  gap: 15px;
  background: ${(p) => p.theme.palette.white};
`;
export const ImageContainer = styled.div`
  width: 250px;
  height: 143px;
  position: relative;
  img {
    width: 250px;
    height: 100%;
  }
`;

export const GalleryTitle = styled.span`
  padding: 15px 0 0px 15px;
  font-size: 18px;
  font-weight: bold;
  color: ${(p) => p.theme.palette.darkGray};
`;

export const HorizontalImageList = styled(HorizontalScrollableList)`
  width: 100vw;
`;

export const LegendTitle = styled.span`
  height: 15px;
  opacity: 0.75;
  font-size: 12px;
  font-weight: 600;
  color: ${(p) => p.theme.palette.darkGray};
  line-height: normal;
`;

export const LegendItem = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  svg {
    width: 20px;
    height: 20px;
  }
`;
export const Legend = styled.div`
  display: flex;
  width: 100%;
  height: 58px;
  padding: 10px 20px;
  background-color: ${(p) => p.theme.palette.white};
  div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  position: relative;
  &::after {
    content: '';
    width: 1px;
    height: 38px;
    background-color: ${(p) => p.theme.palette.lightsSilver};
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    position: absolute;
  }
`;

export const FeatureHeader = styled.summary`
  list-style: none;
  padding: 15px 0;
  position: relative;
`;

export const ChevronUp = styled(UpArrowIcon)``;
export const ChevronDown = styled(DownArrowIcon)``;

export const FeatureContainer = styled.details`
  background-color: ${(p) => p.theme.palette.white};
  margin-bottom: 20px;
  padding: 0 15px;
  &:first-of-type {
    margin-top: 20px;
  }
  ${FeatureHeader} {
    ${ChevronUp}, ${ChevronDown} {
      position: absolute;
      width: 20px;
      height: 20px;
      right: 15px;
      top: 0;
      margin: auto;
      bottom: 0;
    }
  }
  & {
    ${ChevronUp} {
      display: none;
    }
    ${ChevronDown} {
      display: block;
    }
  }
  &[open] {
    padding-bottom: 20px;
    ${ChevronDown} {
      display: none;
    }
    ${ChevronUp} {
      display: block;
    }
  }
`;

export const GalleryContainerMobile = styled.div`
  max-height: 100%;
  width: 100%;
  background-color: ${(p) => p.theme.palette.darkGrey};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const RoomFeaturesContainer = styled.div`
  padding: 15px;
`;

export const ModalTitle = styled.span`
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
  margin: 8px 0;
  color: ${(p) => p.theme.palette.darkGrey};
`;
